import { useGetInsightClaimQuery } from '@/features/claims/ticketsApi';
import { useGetDealRowQuery } from '@/features/deals/dealsApi';

const useDealContext = (dealId) => {
	const {
		currentData: dealRow,
		isLoading,
		isFetching,
		isUninitialized,
	} = useGetDealRowQuery(dealId, {
		skip: !dealId,
	});

	const { currentData: insightClaim } = useGetInsightClaimQuery(dealId, {
		skip: !dealId || !dealRow?.claimId,
	});

	const context = {
		dealRow,
		claim: insightClaim ?? {},
		isLoadingDeal: isLoading || isFetching || isUninitialized,
	};
	return context;
};

export default useDealContext;
